export enum EnumTipoNaturaleza {
  Firme = 1,
  Interrumpible,
  FirmeCliente,
  InterrumpibleClienteA,
  InterrumpibleClienteB
}
